import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type CrossfadePanelProps = {
  children: ReactNode;
  className?: string;
  delay?: number;
  panelKey: string;
  // Opacity-only fade (no Y translate). Use when wrapping table content: a lingering
  // transform on a table makes its 1px row dividers render as visible gray seams.
  translate?: boolean;
};

// A plain CSS animation, not framer-motion: Chrome showed a one-frame flash when
// framer-motion handed its finished opacity animation back to inline styles. A new
// panelKey remounts the panel, which replays the entrance.
export const CrossfadePanel: FC<CrossfadePanelProps> = ({
  children,
  className,
  delay = 0,
  panelKey,
  translate = true,
}) => (
  <div
    className={twMerge(translate ? 'animate-reveal-up' : 'animate-reveal-fade', className)}
    key={panelKey}
    style={delay ? { animationDelay: `${delay}s` } : undefined}
  >
    {children}
  </div>
);

CrossfadePanel.displayName = 'CrossfadePanel';
